export default __webpack_public_path__ + "static/media/item7.4f7edfc3.png";